export const FETCH_SKILL_SUCCESS = 'FETCH_SKILL_SUCCESS';
export const FETCH_SKILL_LESSON_SUCCESS = 'FETCH_SKILL_LESSON_SUCCESS';
export const FETCH_UNASSIGNED_SKILLS_SUCCESS = 'FETCH_UNASSIGNED_SKILLS_SUCCESS';